"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { Time } from "@/helpers/time";
interface WaveDropTimeProps {
  readonly timestamp: number;
}

/**
 * A reusable component for displaying timestamps in wave drops
 * Uses the exact same logic as the original WaveDropHeader implementation
 */
const WaveDropTime: React.FC<WaveDropTimeProps> = t0 => {
  const $ = _c(9);
  const {
    timestamp
  } = t0;
  const [isMobile, setIsMobile] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const checkMobile = function checkMobile() {
        const screenSize = window.innerWidth;
        if (screenSize <= 640) {
          setIsMobile(true);
        } else {
          setIsMobile(false);
        }
      };
      checkMobile();
      window.addEventListener("resize", checkMobile);
      return () => window.removeEventListener("resize", checkMobile);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!timestamp) {
    return null;
  }
  let t3;
  if ($[2] !== isMobile || $[3] !== timestamp) {
    t3 = () => {
      const timeObj = Time.millis(timestamp);
      const date = new Date(timestamp);
      const now = new Date();
      const isToday = date.toDateString() === now.toDateString();
      if (isToday) {
        return date.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit"
        });
      }
      if (isMobile) {
        return timeObj.toLocaleDropDateString();
      } else {
        const yesterday = new Date();
        yesterday.setDate(now.getDate() - 1);
        const isYesterday = date.toDateString() === yesterday.toDateString();
        const timeStr = date.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit"
        });
        if (isYesterday) {
          return `Yesterday - ${timeStr}`;
        }
        const sameYear = date.getFullYear() === now.getFullYear();
        const dateStr = date.toLocaleDateString(undefined, {
          month: "short",
          day: "2-digit",
          ...(sameYear ? {} : {
            year: "numeric"
          })
        });
        return `${dateStr} - ${timeStr}`;
      }
    };
    $[2] = isMobile;
    $[3] = timestamp;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const formatTime = t3;
  let t4;
  if ($[5] !== formatTime) {
    t4 = formatTime();
    $[5] = formatTime;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p className="tw-text-xs tw-mb-0 tw-whitespace-nowrap tw-font-normal tw-leading-none tw-text-iron-500">{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default WaveDropTime;